export class DocumentUtil {

    static showScroll() {
        document.body.style.overflow = 'auto';
    }

    static hideScroll() {
        document.body.style.overflow = 'hidden';
    }

}



// WEBPACK FOOTER //
// ./src/app/models/utils/document.util.ts